// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import 'trix';
import 'chartkick/chart.js';
import { Tooltip } from 'bootstrap';
import feather from 'feather-icons';
import Rails from '@rails/ujs';
import * as ActiveStorage from '@rails/activestorage';
import '@rails/actiontext';
import SenderEmailsController from './controllers/sender_emails_controller';

Rails.start();
ActiveStorage.start();

window.copyValue = function (id) {
  const el = document.getElementById(id);
  el.type = 'text';
  el.select();
  document.execCommand('copy');
  el.type = 'hidden';
};

document.addEventListener('DOMContentLoaded', function () {
  feather.replace();
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => new Tooltip(el));
  document.querySelectorAll('[data-controller="sender-emails"]').forEach(el => new SenderEmailsController(el));
});
